var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-image"},[(_vm.messages > 0)?_c('span',{staticClass:"intercom-messages"}):_vm._e(),_c('img',{attrs:{"src":_vm.profilePicture}})])
}
var staticRenderFns = []

export { render, staticRenderFns }